

document.addEventListener('DOMContentLoaded', function() {

setTimeout(() => {
    // Función para cambiar la cantidad de productos, específica a cada tarjeta
    document.querySelectorAll('.mox-subs-container').forEach(container => {
        const quantityDisplay = container.querySelector('.mox-subs-quantity-display');
        let quantity = parseInt(quantityDisplay.textContent);
        container.querySelector('.mox-subs-increase').addEventListener('click', () => {
            quantity++;
            quantityDisplay.textContent = quantity;
        });

        container.querySelector('.mox-subs-decrease').addEventListener('click', () => {
            if (quantity > 1) {
                quantity--;
                quantityDisplay.textContent = quantity;
            }
        });
    });
  
}, "1000");

    const checkboxes = document.querySelectorAll('.pdp-selector-checkbox');

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            if (this.checked) {
                checkboxes.forEach(cb => {
                    if (cb.checked == true) {
                        cb.checked = false;
                    }
                });
this.checked = true
            }
        });
    });


  document.querySelectorAll('.t4s-form__product .t4s-swatch__list .t4s-swatch__item').forEach(item => {
    item.addEventListener('click', function () {
      setTimeout(() => {

        let subs_price = document.querySelector('#current_variant_price');
                            
        let current_variant_price = 
          document.querySelector('.t4s-product__info-container.t4s-product__info-container--sticky .t4s-product-price ins') ||
          document.querySelector('.t4s-product__info-container.t4s-product__info-container--sticky .t4s-product-price');


            if (current_variant_price) {
                let priceText = current_variant_price.textContent;
                let cleanPrice = priceText.replace(/[$.,\s]/g, '');
                subs_price.value = cleanPrice;
            }
    
        // Leer el valor de data-value
        const dataValue = this.getAttribute('data-value-position');

        const match = dataValue.match(/\d+/);
        const number = match ? match[0] : null;

        if (number) {

            document.querySelectorAll('.tab-container .discount-label').forEach(tab => {
                tab.style.display = 'none';
            });

            // Mostrar el elemento correspondiente al número encontrado
            const targetTab = document.querySelector(`.tab-container .dis-standard-${number}`);
            if (targetTab) {
                targetTab.style.display = '';
            }

            document.querySelectorAll('.tab-container .discount-label-subs').forEach(tab => {
                tab.style.display = 'none';
            });

            // Mostrar el elemento correspondiente al número encontrado
            const targetTabSubs = document.querySelector(`.tab-container .dis-standard-subs-${number}`);
            if (targetTabSubs) {
                targetTabSubs.style.display = '';
            }

        }
        calculatePrice()
        $('.tab.active').click();
      }, 50);        
    });
   });


  
});

const deliveryOptions = document.querySelector("#delivery-options");

// Función para actualizar atributos del botón de agregar al carrito
function updateAddToCartButton(frequency, subscriptionPrice, discountApplied, attributeName, variantId) {
  // Buscar el botón - primero en formularios, luego globalmente
  var addToCartButton = null;
  
  // Buscar en formularios de producto (tanto main-product como featured-product)
  var productForms = document.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
  for (var i = 0; i < productForms.length; i++) {
    // Priorizar botones con data-action-atc, luego data-atc-form, luego submit
    addToCartButton = productForms[i].querySelector('[data-action-atc]') || 
                     productForms[i].querySelector('[data-atc-form]') ||
                     productForms[i].querySelector('button[type="submit"][name="add"]');
    if (addToCartButton) break;
  }
  
  // Si no se encuentra, buscar globalmente
  if (!addToCartButton) {
    addToCartButton = document.querySelector('[data-action-atc]') || 
                     document.querySelector('[data-atc-form]') ||
                     document.querySelector('button[type="submit"][name="add"]');
  }
  
  if (!addToCartButton) {
    console.warn('No se encontró el botón de agregar al carrito');
    return;
  }
  
  if (frequency !== null && subscriptionPrice !== null && discountApplied !== null && attributeName) {
    // Modo suscripción: establecer atributos
    // Asegurar que todos los valores sean strings válidos (no null, undefined, o vacíos)
    if (variantId) addToCartButton.setAttribute('data-variant-id', String(variantId));
    addToCartButton.setAttribute('data-variant-subscription_price', String(subscriptionPrice));
    addToCartButton.setAttribute('data-variant-subscription_freq', String(frequency));
    addToCartButton.setAttribute('data-variant-subscription_discount_applied', String(discountApplied));
    addToCartButton.setAttribute('data-variant-dcto_attribute_name', String(attributeName));
    
    // CRÍTICO: interactable.min.js busca [data-action-atc] y lee los atributos del elemento clickeado
    // En featured-product el botón tiene data-atc-form, pero interactable.min.js busca data-action-atc
    // Necesitamos asegurar que el botón tenga data-action-atc ANTES de que se haga clic
    if (!addToCartButton.hasAttribute('data-action-atc')) {
      addToCartButton.setAttribute('data-action-atc', '');
      console.log('Agregado data-action-atc al botón para que interactable.min.js lo detecte');
    }
    
    // También asegurar que tenga data-variant-id si no lo tiene
    if (!addToCartButton.hasAttribute('data-variant-id') && variantId) {
      addToCartButton.setAttribute('data-variant-id', String(variantId));
    }
    
    // Debug: verificar que los atributos se establecieron correctamente
    console.log('Atributos de suscripción establecidos en el botón:', {
      'data-variant-id': addToCartButton.getAttribute('data-variant-id'),
      'data-variant-subscription_price': addToCartButton.getAttribute('data-variant-subscription_price'),
      'data-variant-subscription_freq': addToCartButton.getAttribute('data-variant-subscription_freq'),
      'data-variant-subscription_discount_applied': addToCartButton.getAttribute('data-variant-subscription_discount_applied'),
      'data-variant-dcto_attribute_name': addToCartButton.getAttribute('data-variant-dcto_attribute_name'),
      'data-action-atc': addToCartButton.hasAttribute('data-action-atc'),
      'data-atc-form': addToCartButton.hasAttribute('data-atc-form'),
      'type': addToCartButton.getAttribute('type'),
      'buttonId': addToCartButton.id || 'sin-id',
      'buttonClass': addToCartButton.className
    });
  } else {
    // Modo compra única: remover atributos de suscripción
    addToCartButton.removeAttribute('data-variant-subscription_price');
    addToCartButton.removeAttribute('data-variant-subscription_freq');
    addToCartButton.removeAttribute('data-variant-subscription_discount_applied');
    addToCartButton.removeAttribute('data-variant-dcto_attribute_name');
  }
}

function showTabContent(event, tabId, discountApplied, attributeName) {
  // Ocultar todo el contenido de las pestañas
  var contents = document.querySelectorAll('.tab-content');
  contents.forEach(function(content) {
    content.classList.remove('active');
    content.style.display = 'none';
  });

  // Quitar la clase 'active' de todas las pestañas
  var tabs = document.querySelectorAll('.tab');
  tabs.forEach(function(tab) {
    tab.classList.remove('active');
    tab.classList.add('inactive');
  });

  // Mostrar el contenido seleccionado y marcar la pestaña activa
  var tabContent = document.getElementById(tabId);
  if (tabContent) {
    tabContent.classList.add('active');
    tabContent.style.display = 'block';
    tabContent.style.setProperty('display', 'block', 'important');
  }
  event.currentTarget.classList.add('active');
  event.currentTarget.classList.remove('inactive');

  // Lógica para tab1 (compra única)
  if (tabId === 'tab1') {
    var lineItemField = document.querySelector('.t4s-main-area .line-item-property__field') || 
                        document.querySelector('.line-item-property__field');
    if (lineItemField) {
      lineItemField.innerHTML = '<input id="subscription-price" type="text" name="properties[Compra Unica]">';
    }
    // Limpiar atributos del botón
    updateAddToCartButton(null);
  }

  // Lógica para tab2 (suscripción)
  if (tabId === 'tab2') {
    var deliveryOptionsAvai = document.querySelector('#delivery-options');
    var frequency = deliveryOptionsAvai ? deliveryOptionsAvai.value : '';
    var original_price = parseFloat($("#current_variant_price").val()) || 0;
    var subscription_discount = parseFloat($("#subscription_discount").val()) || 0;
    var subscription_price = original_price - (original_price * subscription_discount / 100);
    var variant_id = $("#current_variant_id").val();
    
    // Validar que tengamos todos los valores necesarios
    if (!frequency || !subscription_price || !discountApplied || !attributeName || !variant_id) {
      console.warn('Faltan valores para la suscripción:', {
        frequency: frequency,
        subscription_price: subscription_price,
        discountApplied: discountApplied,
        attributeName: attributeName,
        variant_id: variant_id
      });
    }
    
    // Actualizar campos ocultos del formulario - buscar en múltiples lugares
    var lineItemField = document.querySelector('.t4s-main-area .line-item-property__field') || 
                        document.querySelector('.line-item-property__field') ||
                        document.querySelector('p.line-item-property__field') ||
                        document.querySelector('form[data-type="add-to-cart-form"] .line-item-property__field');
    
    if (!lineItemField) {
      // Si no existe, crear el campo dentro del formulario
      var productForm = document.querySelector('form[data-type="add-to-cart-form"]') || 
                       document.querySelector('form[action*="/cart/add"]');
      if (productForm) {
        lineItemField = document.createElement('p');
        lineItemField.className = 'line-item-property__field';
        lineItemField.style.display = 'none';
        // Insertar antes del botón de submit
        var submitButton = productForm.querySelector('button[type="submit"], button[data-atc-form]');
        if (submitButton) {
          productForm.insertBefore(lineItemField, submitButton);
        } else {
          productForm.appendChild(lineItemField);
        }
      }
    }
    
    if (lineItemField) {
      lineItemField.innerHTML = `
        <input id="subscription-price" type="hidden" name="properties[_subscription_price]" value="${subscription_price}">
        <input id="subscription-freq" type="hidden" name="properties[_subscription_freq]" value="${frequency}">
        <input type="hidden" name="properties[_subscription_discount_applied]" value="${discountApplied}">       
        <input id="${attributeName}" type="hidden" name="properties[${attributeName}]" value="${discountApplied}">
      `;
      console.log('Campos ocultos actualizados:', lineItemField.innerHTML);
    } else {
      console.warn('No se encontró ni se pudo crear el campo line-item-property__field');
    }
    
    // Actualizar atributos del botón inmediatamente y también con delays
    // para asegurar que se establezcan antes de cualquier clic
    updateAddToCartButton(frequency, subscription_price, discountApplied, attributeName, variant_id);
    
    // También actualizar con delays para asegurar que se ejecute después de otros scripts
    // Usar más delays y más tiempo para featured-product que puede cargar más tarde
    [50, 100, 200, 300, 500, 750, 1000].forEach(function(delay) {
      setTimeout(function() {
        updateAddToCartButton(frequency, subscription_price, discountApplied, attributeName, variant_id);
      }, delay);
    });
    
    // También actualizar cuando el DOM esté completamente listo
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(function() {
          updateAddToCartButton(frequency, subscription_price, discountApplied, attributeName, variant_id);
        }, 100);
      });
    }
  }

  // Listener para cambios de frecuencia
  setTimeout(function() {
    var deliveryOptions = document.querySelector("#delivery-options");
    var subscriptionFreq = document.querySelector("#subscription-freq");
    
    if (deliveryOptions && subscriptionFreq) {
      deliveryOptions.addEventListener("change", function() {
        var newFrequency = this.value;
        subscriptionFreq.value = newFrequency;
        
        // Actualizar atributo del botón si está en modo suscripción
        var addToCartButton = null;
        var productForms = document.querySelectorAll('form[action*="/cart/add"]');
        for (var i = 0; i < productForms.length; i++) {
          addToCartButton = productForms[i].querySelector('[data-action-atc]') || 
                           productForms[i].querySelector('[data-atc-form]') ||
                           productForms[i].querySelector('button[type="submit"][name="add"]');
          if (addToCartButton) break;
        }
        
        if (!addToCartButton) {
          addToCartButton = document.querySelector('[data-action-atc]') || 
                           document.querySelector('[data-atc-form]') ||
                           document.querySelector('button[type="submit"][name="add"]');
        }
        
        if (addToCartButton && addToCartButton.hasAttribute('data-variant-subscription_price')) {
          var original_price = parseFloat($("#current_variant_price").val()) || 0;
          var subscription_discount = parseFloat($("#subscription_discount").val()) || 0;
          var subscription_price = original_price - (original_price * subscription_discount / 100);
          var variant_id = $("#current_variant_id").val();
          var discountApplied = $("#subscription_discount").val();
          var attributeName = $("#dcto_attribute_name").val();
          
          // Actualizar todos los atributos del botón
          updateAddToCartButton(newFrequency, subscription_price, discountApplied, attributeName, variant_id);
          
          // También actualizar el campo oculto si existe
          var productForm = document.querySelector('form[data-type="add-to-cart-form"]') || 
                           document.querySelector('form[action*="/cart/add"]');
          if (productForm) {
            var subscriptionFreqField = productForm.querySelector('input[name="properties[_subscription_freq]"]');
            if (subscriptionFreqField) {
              subscriptionFreqField.value = newFrequency;
            }
          }
        }
      });
    }
  }, 500);
}